import { createValidation } from '../../../utils/validation';
export const createComplaintCategoryNonMedicalValidation = (fields) => { const validation = createValidation(fields); return { schema: validation.schema, validateData: validation.validateData, validateComplaintCategoryNonMedicalData: validation.validateData, validateField: validation.validateField }; };
export default createComplaintCategoryNonMedicalValidation;

